import { stringsActions } from 'store/strings'
import CoreLayout from '../layouts/CoreLayout/CoreLayout'
import SignUpRoute from './SignUp'

export const createRoutes = store => {
  return {
    path: '/',
    component: CoreLayout,
    indexRoute: { onEnter: (nextState, replace) => replace('/signup') },
    getChildRoutes(location, cb) {
      const state = store.getState()
      const { participant, strings } = state
      if (!strings[Object.keys(strings)[0]]) {
        const locale = participant.participant.default_locale
        store.dispatch(stringsActions.onFetchApplangaStrings(locale))
      }
      cb(null, [SignUpRoute(store)])
    },
    store,
  }
}

export default createRoutes



// WEBPACK FOOTER //
// ./src/routes/index.js